<template>
    <b-navbar toggleable="md">
        <div class="mx-auto d-sm-flex d-block flex-sm-nowrap">
            <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
            <b-collapse is-nav id="nav_collapse" class="text-center collapse navbar-collapse">
                <b-navbar-nav>
                    <b-nav-item :to="'/'" exact>
                        {{ $t('menu.items.home') }}
                    </b-nav-item>
                    <b-nav-item :to="'/profile'">
                        {{ $t('menu.items.profile') }}
                    </b-nav-item>
                    <b-nav-item :to="'/guardians'">
                        {{ $t('menu.items.guardians.topLevel') }}
                    </b-nav-item>
                    <b-nav-item :to="'/photos'">
                        {{ $t('menu.items.photos') }}
                    </b-nav-item>
                    <b-nav-item :to="'/documents'">
                        {{ $t('menu.items.documents') }}
                    </b-nav-item>
                    <b-nav-item :to="'/contacts'">
                        {{ $t('menu.items.contacts') }}
                    </b-nav-item>
                    <b-nav-item :to="'/pets'">
                        {{ $t('menu.items.pets') }}
                    </b-nav-item>
                    <b-nav-item :to="'/my-funeral'">
                        {{ $t('menu.items.funeral.topLevel') }}
                    </b-nav-item>
                    <!--<b-nav-item :to="'/links'">-->
                    <!--{{ $t('menu.items.links') }}-->
                    <!--</b-nav-item>-->
                    <b-nav-item :to="'/account'">
                        {{ $t('menu.items.account') }}
                    </b-nav-item>
                    <b-nav-item v-on:click="logout">
                        {{ $t('menu.items.logout') }}
                    </b-nav-item>
                    <b-nav-item-dropdown :text="$t('menu.items.languageSwitcher')" right>
                        <b-dropdown-item href="javascript:void(0)" @click="switchLang('de')">Deutsch</b-dropdown-item>
                        <b-dropdown-item href="javascript:void(0)" @click="switchLang('en')">English</b-dropdown-item>
                    </b-nav-item-dropdown>
                </b-navbar-nav>
            </b-collapse>
        </div>
    </b-navbar>
</template>

<script>
    import {mapActions} from 'vuex'
    import {AUTH_ACTION_LOG_OUT, AUTH_NAMESPACE} from '../store/modules/auth-types'

    export default {
        name: 'navmenu',
        methods: {
            ...mapActions(AUTH_NAMESPACE, {
                logOut: AUTH_ACTION_LOG_OUT
            }),
            switchLang: function (lang) {
                this.$i18n.locale = lang
            },
            logout () {
                this.logOut()
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../assets/scss/custom/vars';

    #nav_collapse > ul > li > a {
        color: white;
        &:hover {
            color: $omyfu-hover;
            text-decoration: none;
        }
    }

    #nav_collapse > ul > li > a.active {
        color: $omyfu-yellow;
    }

    .navbar {
        background-color: $omyfu-red;
        padding: 0px;
        color: white;
    }
</style>



// WEBPACK FOOTER //
// src/components/MenuComponent.vue